<template>
  <footer class="py-6 px-8 md:px-16 lg:px-24 xl:px-40 text-center text-sm text-slate-500 dark:text-slate-400 border-t border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800">
    © {{ currentYear }} Portinos. Todos los derechos reservados. Version 1.0.3.
  </footer>
</template>

<script>
export default {
  name: 'FooterSection',
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
}
</script>